import React from 'react';
import { BoxIcon } from 'lucide-react';
export interface TabItem<T extends string> {
  id: T;
  label: string;
  icon: BoxIcon;
}
interface TabBarProps<T extends string> {
  tabs: TabItem<T>[];
  activeTab: T;
  onTabChange: (tabId: T) => void;
  variant?: 'indigo' | 'slate' | 'emerald';
}
export function TabBar<T extends string>({
  tabs,
  activeTab,
  onTabChange,
  variant = 'indigo'
}: TabBarProps<T>) {
  const activeClasses = {
    indigo: 'bg-indigo-600 text-white shadow-md',
    slate: 'bg-slate-800 text-white shadow-md',
    emerald: 'bg-emerald-600 text-white shadow-md'
  };
  return <div className="flex gap-1 p-1.5 bg-white rounded-xl border border-slate-200 shadow-sm overflow-x-auto scrollbar-hide w-full sm:w-fit" data-id="element-5110">
      {tabs.map(tab => {
      const isActive = activeTab === tab.id;
      const Icon = tab.icon;
      return <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`
              flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-bold transition-all whitespace-nowrap
              ${isActive ? activeClasses[variant] : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'}
            `} data-id="element-5111">
            <Icon className="w-4 h-4" data-id="element-5112" />
            {tab.label}
          </button>;
    })}
    </div>;
}